import styled from 'styled-components';

export const Container = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;

    > aside {
        margin-right: 0.5rem;
        color: var(--color-text);
    }

    > main {
        > h4 {
            font-size: 0.9rem;
            color: var(--color-text);
        }
    }
`;
